import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function NuevaReferenciaInventario() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    const [nombre, setNombre] = useState('');
    const [categoria, setCategoria] = useState('equipo');

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: '+error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        /*if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }*/

        console.log('Client: '+client.client_id);

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            client_id: client.client_id,
            nombre: nombre,
            categoria: categoria
        };
        
        console.log(conf);
        axios.post('/referencia-inventario', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg','La Referencia De Inventario "'+nombre+'" Ha Sido Creada Exitosamente');
                    history.push('/referencias-inventario');
                }
            )
            .catch(
                err => {
                    console.log(err.response.data.errors)
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-inventario">Parámetros de Inventario</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/referencias-inventario">Referencias de Inventario</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Nueva Referencia de Inventario</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nueva Referencia de Inventario</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-10">
                                
                            <form id="role-form" onSubmit={handleSubmit}>
                                <div className="card">
                                    <div id="infobasica">
                                        <div className="card-body">

                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombre">Nombre</label>
                                                        <input type="text" name="nombre" className="form-control" id="nombre" onChange={(e) => setNombre(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="categoria">Categoría</label>
                                                        <select name="categoria" id="categoria" className="form-control" onChange={(e) => setCategoria(e.target.value)}>
                                                            <option value="equipo">Equipo</option>
                                                            <option value="medicamento">Medicamento</option>
                                                            <option value="producto">Dispositivo Médico</option>
                                                            <option value="insumo">Insumo</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: '30px'}}>
                                    <div className="col-md-6">
                                        <button type="submit" className="btn btn-primary">
                                            Crear Referencia&nbsp;
                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                            
                                        </button>
                                    </div>
                                </div>
                            </form>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default NuevaReferenciaInventario;